var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({
    backgroundImage: ("url(" + _vm.url + ")"),
  }),on:{"click":_vm.goToShowPage}},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"play"},[_c('div',{staticClass:"head"},[_c('h3',[_vm._v(_vm._s(_vm.ShowTitle))]),_c('hr')]),_c('button',{attrs:{"name":"play"}})]),_c('div',{staticClass:"desc"},[_c('p',[_vm._v(_vm._s(_vm.Desc))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }